export default "__VITE_ASSET__CzgMD_tZ__"